<app-standard-room-menu></app-standard-room-menu>
<app-it-room-menu></app-it-room-menu>
<app-procedure-room-menu></app-procedure-room-menu>
<app-operating-theatre-menu></app-operating-theatre-menu>
<app-isolation-room-menu></app-isolation-room-menu>
